import config from '@/utility/config';
import { downloadCSV } from '@/utility/helpers';
import { timeRequest } from '@/utility/timeRequest';

import { getAxiosErrorMsg } from './helpers';
import adminProtectedAxiosRequest from './helpers/adminProtectedAxiosRequest';
import { getCsvApiToken } from './helpers/getCsvApiToken';
import { convertObjectToQueryString } from './helpers/queryString';

const {
  communityApiBasePath,
  isBackendCdnEnabled,
  communityApiBasePathCdn
} = config;

export const setMoneyPageViewedService = async (communityId, payload) => {
  try {
    const basePath = isBackendCdnEnabled
      ? communityApiBasePathCdn
      : communityApiBasePath;
    const path = `${basePath}/api/v1/communities/${communityId}/money-page-viewed`;

    const res = await timeRequest(
      () => adminProtectedAxiosRequest.patch(path, payload),
      'PATCH: money-page-viewed'
    );

    return { data: res.data, error: null };
  } catch (error) {
    return { error: error?.response?.data?.message ?? error.message };
  }
};

export const fetchMoneyPageTransactions = async (communityId, payload) => {
  try {
    const path = `${communityApiBasePath}/api/v1/communities/${communityId}/transactions`;
    const res = await adminProtectedAxiosRequest.get(path, {
      params: payload
    });
    return { data: res.data.data, error: null };
  } catch (error) {
    return { error: error?.response?.data?.message ?? error.message };
  }
};

export const fetchMoneyPageEarnings = async (communityId, payload) => {
  try {
    const path = `${communityApiBasePath}/api/v1/communities/${communityId}/earnings`;
    const res = await adminProtectedAxiosRequest.get(path, {
      params: payload
    });
    return { data: res.data.data, error: null };
  } catch (error) {
    return { error: error?.response?.data?.message ?? error.message };
  }
};

export const fetchMembershipCounts = async (
  communityId,
  countTypes = 'payment_interval'
) => {
  try {
    const path = `${communityApiBasePath}/api/v1/membership/community/${communityId}/count?countTypes=${countTypes}`;
    const res = await adminProtectedAxiosRequest.get(path);
    return { data: res.data.data, error: null };
  } catch (error) {
    return { error: getAxiosErrorMsg(error) };
  }
};

export const fetchMoneyPageRevenues = async (communityId, payload) => {
  try {
    const path = `${communityApiBasePath}/api/v1/communities/${communityId}/transactions/revenues`;
    const res = await adminProtectedAxiosRequest.get(path, {
      params: payload
    });
    return { data: res.data, error: null };
  } catch (error) {
    return { error: getAxiosErrorMsg(error) };
  }
};

export const fetchMoneyPageExportCsv = async (communityId, payload) => {
  try {
    const path = `${communityApiBasePath}/api/v1/communities/${communityId}/transactions/csv`;
    const res = await adminProtectedAxiosRequest.get(path, {
      params: payload
    });
    return { data: res.data, error: null };
  } catch (error) {
    return { error: error?.response?.data?.message ?? error.message };
  }
};

export const exportMoneyPageTransactionsToCSV = async ({
  communityId,
  params
}) => {
  const { data, error } = await getCsvApiToken(communityId);
  if (error) {
    return { error: getAxiosErrorMsg(error) };
  }
  const queryString = convertObjectToQueryString({
    ...params,
    token: data
  });
  const apiPath = `${config.communityApiBasePath}/api/v1/communities/${communityId}/transactions/csv?${queryString}`;
  downloadCSV(apiPath);
  return { error: false };
};

export const requestRefundService = async (
  communityId,
  transactionId,
  payload
) => {
  try {
    const path = `${communityApiBasePath}/api/v1/communities/${communityId}/transactions/${transactionId}/refunds/request`;
    const res = await adminProtectedAxiosRequest.post(path, {
      ...payload
    });
    return { data: res.data, error: null };
  } catch (error) {
    return { error: error?.response?.data?.message ?? error.message };
  }
};

export const getEntityOptionsForTxnFilter = ({
  entity,
  communityId,
  search,
  pageNo,
  pageSize
}) => {
  const path = `${communityApiBasePath}/api/v1/communities/${communityId}/transactions/filters/${entity}`;
  return adminProtectedAxiosRequest.get(path, {
    params: {
      search,
      pageNo,
      pageSize
    }
  });
};
